import React, { useEffect, useState } from "react";
import "./CreditScore.css";
import needleImage from "./needles.png";
import meterBackground from "./meter.png";

const CreditScoreMeter = () => {
  const [input, setInput] = useState(""); // Input state
  const [isFocused, setIsFocused] = useState(false); //
  const [angle, setAngle] = useState(-90); // Initial angle
  const handleInputChange = (e) => {
    setInput(e.target.value);
  };
  const handleInputFocus = () => {
    setIsFocused(true);
  };

  const handleInputBlur = () => {
    setIsFocused(false); // Trigger return to -90° when blurred
  };

  useEffect(() => {
    let intervalId;
    if (isFocused) {
      intervalId = setInterval(() => {
        setAngle((prevAngle) => {
          if (prevAngle === 90) {
            return -90;
          }
          return 90;
        });
      }, 2000);
    } else {
      setAngle(-90);
      clearInterval(intervalId);
    }
    return () => {
      clearInterval(intervalId);
    };
  }, [isFocused]);
  const handleCheckScore = () => {
    if (input.length === 10) {
      alert(`OTP will be sent to ${input}`);
    } else {
      alert("Please enter a valid 10-digit mobile number.");
    }
  };

  return (
    <div className="credit-score-meter-container credit-score-container">
      <div className="credit-score-info">
        <p>Check your Credit Score for free</p>

        <div className="input-section">
          <p className="powered-by">Powered by -------</p>
          <input
            type="text"
            placeholder="Start typing..."
            value={input}
            onFocus={handleInputFocus}
            onBlur={handleInputBlur}
            onChange={handleInputChange}
            className="mobile-input"
          />
          <p className="input-help-text">
            An OTP will be sent for verification
          </p>
        </div>
        <button className="check-score-button" onClick={handleCheckScore}>
          Check your score
        </button>
      </div>
      <div
        className="credit-score-meter"
        style={{ backgroundImage: `url(${meterBackground})` }}
      >
        <div
          className={`needle`}
          style={{
            backgroundImage: `url(${needleImage})`,
            transform: `rotate(${angle}deg)`,
          }}
        ></div>
      </div>
    </div>
  );
};

export default CreditScoreMeter;
